import { REFERRAL } from '@wetransfer/transfer/constant/routes';
import Helper from '@wetransfer/transfer/helper';
import { createPricingRoute } from '@wetransfer/transfer/helper/routeFactory';
import {
  userHasProOrPlusTier,
  getPlanTier,
} from '@wetransfer/transfer/helper/user';

export default {
  projectsItem: {
    name: 'navigation.user.items.projects',
    path: '/projects',
    items: [],
  },
  helpItem: {
    name: 'navigation.help.name',
    path: '/help',
    items: [],
    trackEvent: {
      category: 'navigation_bar',
      action: 'clickNavHelp',
    },
    accountTrackEvent: {
      category: 'navigation_bar',
      action: 'clickAccountHelp',
    },
  },
  featuresItem: (user) => ({
    items: [
      {
        url: 'https://wetransfer.com/explore/all-features',
        name: 'navigation.features.all',
        trackEvent: {
          category: 'navigation_bar',
          action: 'clickNavFeaturesAll',
          property: 'in_drop_down',
          label: getPlanTier(user) || 'anonymous',
        },
        shouldBrowserHandle: true,
        target: '_blank',
      },
      {
        url: 'https://wetransfer.com/explore/file-sharing',
        name: 'navigation.features.file_sharing',
        trackEvent: {
          category: 'navigation_bar',
          action: 'clickNavFeaturesFileSharing',
          property: 'in_drop_down',
          label: getPlanTier(user) || 'anonymous',
        },
        shouldBrowserHandle: true,
        target: '_blank',
      },
      {
        url: 'https://wetransfer.com/explore/teams',
        name: 'navigation.features.collaboration',
        trackEvent: {
          category: 'navigation_bar',
          action: 'clickNavFeaturesCollaboration',
          property: 'in_drop_down',
          label: getPlanTier(user) || 'anonymous',
        },
        shouldBrowserHandle: true,
        target: '_blank',
      },
      {
        url: 'https://wetransfer.com/explore/security',
        name: 'navigation.features.security',
        trackEvent: {
          category: 'navigation_bar',
          action: 'clickNavFeaturesDataSecurity',
          property: 'in_drop_down',
          label: getPlanTier(user) || 'anonymous',
        },
        shouldBrowserHandle: true,
        target: '_blank',
      },
      {
        url: 'https://wetransfer.com/explore/branding',
        name: 'navigation.features.branding',
        trackEvent: {
          category: 'navigation_bar',
          action: 'clickNavFeaturesBranding',
          property: 'in_drop_down',
          label: getPlanTier(user) || 'anonymous',
        },
        shouldBrowserHandle: true,
        target: '_blank',
      },
      {
        url: 'https://wetransfer.com/explore/portals-reviews',
        name: 'navigation.features.fast_feedback',
        trackEvent: {
          category: 'navigation_bar',
          action: 'clickNavFeaturesPortals',
          property: 'in_drop_down',
          label: getPlanTier(user) || 'anonymous',
        },
        shouldBrowserHandle: true,
        target: '_blank',
      },
    ],
    name: 'navigation.features.name',
    nestedMenu: true,
  }),
  homeItem: { path: '/', name: 'navigation.home.name' },
  productsItem: {
    url: 'https://wetransfer.com/explore/products',
    name: 'navigation.about_us.items.products',
    target: '_blank',
    shouldBrowserHandle: true,
    trackEvent: {
      category: 'transfer',
      action: 'click_products_nav_bar',
    },
  },
  pricingItem: {
    url: createPricingRoute('NAV_pricing'),
    name: 'navigation.about_us.items.pricing',
    trackEvent: {
      category: 'navigation_bar',
      action: 'clickNavPricing',
    },
  },
  referralItem: {
    url: REFERRAL.route,
    name: 'navigation.referral',
    trackEvent: {
      category: 'navigation_bar',
      action: 'click_referral',
    },
  },
  upgradeAccountItem: (user) => ({
    url: createPricingRoute(
      `WT202004_upgrade_fa_to_${userHasProOrPlusTier(user) ? 'premium' : 'pro'}`
    ),
    name: 'navigation.about_us.items.upgrade',
    sendUserTier: true,
    trackEvent: {
      category: 'navigation_bar',
      action: 'clickNavUpgrade',
    },
  }),
  aboutItem: {
    url: 'https://wetransfer.com/explore',
    name: 'navigation.about_us.name_1_2019',
    target: '_blank',
    shouldBrowserHandle: true,
    trackEvent: {
      category: 'navigation_bar',
      action: 'clickNavCompany',
    },
    accountTrackEvent: {
      category: 'navigation_bar',
      action: 'clickAccountCompany',
    },
  },
  transfersItem: {
    path: '/transfers',
    name: 'navigation.user.items.transfers',
    trackEvent: {
      category: 'navigation_bar',
      action: 'clickNavTransfers',
    },
  },
  contactsItem: {
    path: '/contacts',
    name: 'navigation.user.items.contacts',
    trackEvent: {
      category: 'navigation_bar',
      action: 'clickNavContacts',
    },
  },
  brandingItem: {
    path: '/branding',
    name: 'navigation.branding',
    trackEvent: {
      category: 'navigation_bar',
      action: 'clickNavBranding',
    },
  },
  accountItem: {
    path: '/account',
    name: 'navigation.user.items.account',
    trackEvent: {
      category: 'navigation_bar',
      action: 'clickAccountAccount',
    },
  },
  referFriend: {
    path: REFERRAL.route,
    name: 'refer_friend.title',
  },
  teamsItem: {
    path: Helper.getManageTeamUrl(),
  },
  portalsItem: {
    url: Helper.getPortalsUrl(),
    name: 'navigation.portals',
    shouldBrowserHandle: true,
    target: '_blank',
    trackEvent: {
      category: 'navigation_bar',
      action: 'clickNavPortals',
    },
  },
  signoutItem: {
    path: '/signout',
    name: 'navigation.logout',
  },
  uploadItem: {
    path: '/upload',
    name: 'transfer.buttons.new_transfer',
  },
  upgradeItem: {
    name: 'navigation.about_us.items.upgrade',
    path: '/upgrade',
    queryParams: {
      trk: 'WT202004_upgrade_fa_to_pro',
    },
    trackEvent: {
      category: 'navigation_bar',
      action: 'clickNavUpgrade',
    },
  },
  plusItem: {
    path: '/pro',
    queryParams: {
      trk: 'WT201610_AboutPlus',
    },
    name: 'navigation.about_us.items.plus',
  },
  loginItem: {
    name: 'navigation.login',
    path: '/log-in',
    items: [],
    trackEvent: {
      category: 'navigation_bar',
      action: 'clickNavSignin',
    },
    hasLoadingState: true,
  },
  signupItem: {
    name: 'navigation.signup',
    path: '/pricing',
    items: [],
    hasLoadingState: true,
  },
};
